<template>
    <div
        class="flex items-center justify-between self-center rounded-md bg-blue-600 px-4 py-1 text-xs select-none"
    >
        <span>
            <MdiCog class="-mt-1 inline h-4 w-4 animate-spin text-white" />
        </span>
    </div>
</template>

<script setup>
    import { MdiCog } from 'materialdesignicons-vue3/icons/';
</script>
